var LifeCycle;
(function(LifeCycle2) {
  LifeCycle2["OnConnect"] = "onConnect";
  LifeCycle2["OnInit"] = "onInit";
  LifeCycle2["OnCreate"] = "onCreate";
})(LifeCycle || (LifeCycle = {}));
export {
  LifeCycle
};

//# sourceMappingURL=plugin.js.map